import React, { useMemo } from 'react';

// react virtualized
import { Column, Table, AutoSizer } from 'react-virtualized';
import 'react-virtualized/styles.css';

import { individual_column_style } from '../../../../../../assets/styles/table_custom_style';
import { formatCurrency } from 'utils/fuctions/formatCurrency';
import { maskPhoneNumber } from 'views/CRM/shared/utils/phoneNumberHelpers';
import { maskCpf } from 'views/CRM/shared/utils/cpfCnpjHelpers';
import { maskCnpj } from 'views/CRM/shared/utils/cpfCnpjHelpers';
import { Button } from 'reactstrap';
import ProtocolHistoryModal from '../../ProtocolHistoryModal';
import ClickToCall from 'views/ServicePanel/components/AttendanceContent/components/Modal/ClickToCall';
import { MdPhoneForwarded } from 'react-icons/md';
import { ProtocolNumberWrapper } from '../../ProtocolNumberWrapper';
import { EditProtocolByNumber } from '../../ProtocolList/styled';
import { functionsUseFul } from 'views/Protocol/list/assets/functionsUseFul';
import { OutlineTooltip } from '../../OutlineTooltip';
import { ClientNameWrapper } from '../../ClientNameWrapper';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const reactVirtualizedTableStyle = {
  ...individual_column_style,
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  minWidth: '450px',
  fontSize: '.8125rem'
};

const reactVirtualizedTableHeaderStyle = {
  color: '#8898aa',
  backgroundColor: '#f6f9fc',
  fontWeight: '600',
  paddingTop: '0.75rem',
  paddingBottom: '0.75rem',
  fontSize: '.65rem',
  textTransform: 'uppercase',
  letterSpacing: '1px',
  borderBottom: '1px solid #e9ecef',
  borderTop: '1px solid #e9ecef',
  paddingLeft: '1.5rem',
  paddingRight: '0',
  whiteSpace: 'break-spaces',
  cursor: 'pointer',
  lineHeight: '1.5rem',
  height: '56.5px',
  marginRight: '0px',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const ListTable = ({
  data,
  handleOnSortChange = () => null,
  customFields,
  handleUpdate,
  handleCall,
  disableClickToCall,
  protocolDefaultFieldsDisplaySettings,
  stagePageInfo,
  stageId,
  onTableGrow,
  slaColumnInfo
}) => {
  const { buildProtocolTitleString } = functionsUseFul();

  const activeFieldsCount = useMemo(() => {
    const defaultFields = Object.values(
      protocolDefaultFieldsDisplaySettings
    ).filter((item) => item.isActive);

    return defaultFields.length + customFields.length;
  }, [customFields, protocolDefaultFieldsDisplaySettings]);

  const tableHeight =
    data.length >= 10 ? '638px' : `${data.length * 57 + 75}px`;

  const tableWidth = `${activeFieldsCount * 220}px`;

  const createSLAColumn = slaColumnInfo();

  return (
    <div
      style={{
        overflowX: 'auto',
        overflowY: 'hidden',
        height: tableHeight
      }}
    >
      <div
        style={{
          width: tableWidth ?? '3000px',
          height: '100%'
        }}
      >
        {
          <AutoSizer>
            {({ width, height }) => {
              return (
                <Table
                  width={width}
                  height={height}
                  headerHeight={57}
                  rowHeight={57}
                  style={{
                    height: '100%',
                    padding: '0 1rem 0 1rem'
                  }}
                  rowStyle={{
                    fontSize: '.8125rem',
                    borderBottom: '1px solid #e9ecef'
                  }}
                  headerStyle={{
                    ...reactVirtualizedTableHeaderStyle
                  }}
                  rowCount={data.length || 0}
                  rowGetter={({ index }) => data[index] || {}}
                  onHeaderClick={(event) => {
                    const { dataKey } = event;
                    handleOnSortChange(dataKey);
                  }}
                >
                  <Column
                    label="NÚMERO"
                    cellRenderer={({ rowData }) => {
                      const { number, description } = rowData;
                      return (
                        <Link
                          to={`/admin/protocol/${rowData.id}/update`}
                          onClick={() => handleUpdate(rowData.id)}
                        >
                          <EditProtocolByNumber
                            style={{ color: '#515151' }}
                            onClick={() => handleUpdate(rowData.id)}
                            title={`Clique para editar o protocolo ${number}`}
                          >
                            <ProtocolNumberWrapper
                              number={number}
                              description={description}
                              onClick={() => handleUpdate(rowData.id)}
                              isDescriptionShown={
                                protocolDefaultFieldsDisplaySettings &&
                                protocolDefaultFieldsDisplaySettings.description &&
                                protocolDefaultFieldsDisplaySettings.description
                                  .isRequired
                              }
                            />
                          </EditProtocolByNumber>
                        </Link>
                      );
                    }}
                    dataKey="number"
                    width={250}
                    style={{
                      marginRight: '0px',
                      textAlign: 'center'
                    }}
                    rowStyle={{
                      ...reactVirtualizedTableStyle
                    }}
                  />
                  {protocolDefaultFieldsDisplaySettings &&
                    protocolDefaultFieldsDisplaySettings.title.isActive && (
                      <Column
                        label="TÍTULO"
                        dataKey="title"
                        cellRenderer={({ rowData }) => {
                          return (
                            <div>
                              <span style={{}} id={`title-${rowData.id}`}>
                                {buildProtocolTitleString(rowData.title)}
                              </span>

                              <OutlineTooltip
                                placement={'bottom'}
                                target={`title-${rowData.id}`}
                                message={rowData.title}
                              />
                            </div>
                          );
                        }}
                        width={500}
                        style={{
                          marginRight: '0px'
                        }}
                        rowStyle={{
                          ...reactVirtualizedTableStyle
                        }}
                      />
                    )}

                  {protocolDefaultFieldsDisplaySettings &&
                    protocolDefaultFieldsDisplaySettings.current_status
                      .isActive && (
                      <Column
                        label="Status/Fase"
                        dataKey="status"
                        cellRenderer={({ rowData }) => {
                          return (
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <>
                                <div
                                  style={{
                                    marginRight: '5px',
                                    width: '12px',
                                    height: '12px',
                                    border: '1px solid #CDC9C9',
                                    backgroundColor: `${rowData.corStatus}`
                                  }}
                                ></div>
                                <div>{`${rowData.nomeStatus}`}</div>
                              </>
                            </div>
                          );
                        }}
                        style={{
                          marginRight: '0px',
                          textAlign: 'center'
                        }}
                        width={200}
                        rowStyle={{
                          ...reactVirtualizedTableStyle
                        }}
                      />
                    )}

                  {protocolDefaultFieldsDisplaySettings &&
                    protocolDefaultFieldsDisplaySettings.client_id.isActive && (
                      <Column
                        label="Contato"
                        dataKey="nomeCliente"
                        cellRenderer={({ rowData }) => {
                          const { nomeCliente, telefoneCliente, emailCliente } =
                            rowData;
                          return (
                            <ClientNameWrapper
                              name={nomeCliente}
                              telephone={telefoneCliente}
                              email={emailCliente}
                            />
                          );
                        }}
                        width={150}
                        style={{
                          marginRight: '0px',
                          textAlign: 'center'
                        }}
                        rowStyle={{
                          ...reactVirtualizedTableStyle
                        }}
                      />
                    )}

                  {protocolDefaultFieldsDisplaySettings &&
                    protocolDefaultFieldsDisplaySettings.account_id
                      .isActive && (
                      <Column
                        label="Conta"
                        dataKey="nomeConta"
                        cellDataGetter={({ rowData }) => {
                          return rowData?.nomeConta || '';
                        }}
                        width={150}
                        style={{
                          marginRight: '0px',
                          textAlign: 'center'
                        }}
                        rowStyle={{
                          ...reactVirtualizedTableStyle
                        }}
                      />
                    )}

                  {protocolDefaultFieldsDisplaySettings &&
                    protocolDefaultFieldsDisplaySettings.reason_id.isActive && (
                      <Column
                        label="Motivo"
                        dataKey="nomeMotivo"
                        cellDataGetter={({ rowData }) => {
                          return rowData?.nomeMotivo || '';
                        }}
                        width={300}
                        style={{
                          marginRight: '0px',
                          textAlign: 'center'
                        }}
                        rowStyle={{
                          ...reactVirtualizedTableStyle
                        }}
                      />
                    )}

                  {protocolDefaultFieldsDisplaySettings &&
                    protocolDefaultFieldsDisplaySettings.subreason_id
                      .isActive && (
                      <Column
                        label="Submotivo"
                        dataKey="nomeSubmotivo"
                        cellDataGetter={({ rowData }) => {
                          return rowData?.nomeSubmotivo || '';
                        }}
                        width={300}
                        style={{
                          marginRight: '0px',
                          textAlign: 'center'
                        }}
                        rowStyle={{
                          ...reactVirtualizedTableStyle
                        }}
                      />
                    )}

                  <Column
                    label="Criação"
                    dataKey="creation_date"
                    cellDataGetter={({ rowData }) => {
                      if (!rowData.creation_date) {
                        return '';
                      }
                      const date = new Date(rowData.creation_date);
                      return `${date.toLocaleDateString(
                        'pt-BR'
                      )} às ${date.toLocaleTimeString('pt-BR', {
                        timeZone: 'America/Fortaleza'
                      })}`;
                    }}
                    width={300}
                    style={{
                      marginRight: '0px',
                      textAlign: 'center'
                    }}
                    rowStyle={{
                      ...reactVirtualizedTableStyle
                    }}
                  />
                  <Column
                    label="Responsável"
                    dataKey="nomeResponsavel"
                    cellDataGetter={({ rowData }) => {
                      return rowData.nomeResponsavel || '';
                    }}
                    width={250}
                    style={{
                      marginRight: '0px',
                      textAlign: 'center'
                    }}
                    rowStyle={{
                      ...reactVirtualizedTableStyle
                    }}
                  />
                  <Column
                    label="Última Alteração"
                    dataKey="last_change_date"
                    cellDataGetter={({ rowData }) => {
                      const date = new Date(rowData.last_change_date);
                      return `${date.toLocaleDateString(
                        'pt-BR'
                      )} às ${date.toLocaleTimeString('pt-BR', {
                        timeZone: 'America/Fortaleza'
                      })}`;
                    }}
                    width={300}
                    style={{
                      marginRight: '0px',
                      textAlign: 'center'
                    }}
                    rowStyle={{
                      ...reactVirtualizedTableStyle
                    }}
                  />
                  {customFields.map((field) => {
                    return (
                      <Column
                        key={field.name}
                        label={field.label}
                        dataKey={field.name}
                        cellDataGetter={({ rowData }) => {
                          if (field.type === 'DATE' && !!rowData[field.name]) {
                            return new Date(
                              rowData[field.name]
                            ).toLocaleDateString('pt-br');
                          }

                          if (
                            field.type === 'CURRENCY' &&
                            !!rowData[field.name]
                          ) {
                            return formatCurrency(rowData[field.name]);
                          }

                          if (
                            field.type === 'TELEPHONE' &&
                            !!rowData[field.name]
                          ) {
                            return maskPhoneNumber(rowData[field.name]);
                          }

                          if (field.type === 'CPF' && !!rowData[field.name]) {
                            return maskCpf(rowData[field.name]);
                          }

                          if (field.type === 'CNPJ' && !!rowData[field.name]) {
                            return maskCnpj(rowData[field.name]);
                          }

                          if (
                            field.type === 'MULTIPLE' &&
                            !!rowData[field.name]
                          ) {
                            return rowData[field.name].replace(/;/g, '; ');
                          }

                          return rowData[`${field.name}`];
                        }}
                        width={250}
                        style={{
                          marginRight: '0px',
                          textAlign: 'center'
                        }}
                        rowStyle={{
                          ...reactVirtualizedTableStyle
                        }}
                      />
                    );
                  })}

                  {createSLAColumn.map((column) => {
                    return (
                      <Column
                        key={column.dataKey}
                        label={column.text}
                        dataKey={column.dataKey}
                        cellRenderer={({ rowData }) => {
                          const cellValue = rowData[column.dataField];
                          return column.formatter
                            ? column.formatter(cellValue, rowData)
                            : cellValue;
                        }}
                        width={500}
                        style={{
                          marginRight: '0px',
                          textAlign: 'center'
                        }}
                        rowStyle={{
                          ...reactVirtualizedTableStyle,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      />
                    );
                  })}

                  <Column
                    label="Editar"
                    dataKey="edit"
                    cellRenderer={({ rowData }) => {
                      return (
                        <Link to={`/admin/protocol/${rowData.id}/update`}>
                          <Button
                            title="Editar protocolo"
                            color="info"
                            size="sm"
                            onClick={() => handleUpdate(rowData.id)}
                          >
                            <li className="fas fa-user-edit"></li>
                          </Button>
                        </Link>
                      );
                    }}
                    style={{
                      marginRight: '0px',
                      textAlign: 'center'
                    }}
                    width={150}
                    rowStyle={{
                      ...reactVirtualizedTableStyle
                    }}
                  />
                  <Column
                    label="Histórico"
                    dataKey="history"
                    cellRenderer={({ rowData }) => {
                      return <ProtocolHistoryModal protocolId={rowData.id} />;
                    }}
                    style={{
                      marginRight: '0px',
                      textAlign: 'center'
                    }}
                    width={150}
                    rowStyle={{
                      ...reactVirtualizedTableStyle
                    }}
                  />
                  <Column
                    label="Chamar"
                    dataKey="call"
                    cellRenderer={({ rowData }) => {
                      return (
                        <ClickToCall
                          title={
                            rowData?.cliente?.telefone !== '' ||
                            rowData.telephone !== ''
                              ? `Chamar cliente ${rowData?.cliente?.nome}\nÉ necessário estar logado em um ramal para realizar a chamada!`
                              : `O cliente ${rowData?.cliente?.nome} não possui telefone cadastrado`
                          }
                          callBack={() => handleCall(rowData)}
                          disableClickToCall={
                            (rowData?.cliente?.telefone !== '' ||
                              rowData?.telephone !== '') &&
                            !disableClickToCall
                              ? false
                              : true
                          }
                          icon={<MdPhoneForwarded size={17} color="#fff" />}
                          color="success"
                          isDefaultButtonStyle={true}
                        />
                      );
                    }}
                    style={{
                      marginRight: '0px',
                      textAlign: 'center'
                    }}
                    width={150}
                    rowStyle={{
                      ...reactVirtualizedTableStyle
                    }}
                  />

                  <Column
                    label=""
                    dataKey="lazy"
                    cellRenderer={({ rowIndex }) => {
                      if (
                        data.length >= 20 &&
                        rowIndex === data.length - 4 &&
                        stagePageInfo
                      ) {
                        if (stagePageInfo.count > data.length) {
                          onTableGrow(stageId);
                        }
                      }

                      return <></>;
                    }}
                    style={{
                      marginRight: '0px',
                      textAlign: 'center'
                    }}
                    width={0}
                  />
                </Table>
              );
            }}
          </AutoSizer>
        }
      </div>
    </div>
  );
};
export default ListTable;
